import React, { useEffect } from "react";
import { useOutletContext } from "react-router-dom";
import Form from "./Form";

function Review() {
  const handleChipClick = useOutletContext();

  useEffect(() => {
    handleChipClick("review");
  }, [handleChipClick]);

  return <Form />;
}

export default Review;
